import React from "react";
import Footer from "../components/footer/footer";
import Navbar from "../components/navbar/Navbar";

function TermsAndConditions(props) {
  return (
    <div>
      <div className="nav_container">
        <Navbar fromPage="termsandconditions" />
      </div>
      <div className="bg_img_blog">
        <section className="main_blog_view_container">
          <div className="blog_view_section_under_contianer">
            <div className="terms_container">
              <div className="head">
                <div className="head">
                  <h2>Terms &amp; Conditions:</h2>
                </div>
                <div>
                  <h3 className="left head">I.GENERAL</h3>
                  <p>
                    We are delighted to have you with us. If you continue to
                    browse and use our website you are agreeing to comply with
                    and be bound by the following terms and conditions of use,
                    which together with our privacy policy governing Dynamic
                    World Education Community Private Limited&rsquo;s
                    relationship with it&rsquo;s users relation with our website
                    and the services/ products which you purchase/ booked
                    through this website. The term &lsquo;Dynamic World
                    Education Community Private Limited&rsquo; or
                    &lsquo;us&rsquo; or &lsquo;we&rsquo; refers to the owner of
                    the website. The term &lsquo;you&rsquo; refers to the
                    user/visitors of our website.
                  </p>
                  <p>
                    This T&amp;C is in electronic form is pursuant to the terms
                    of Information Technology Act, 2000, and generated by a
                    computer system and does not require any physical or digital
                    signature.
                  </p>
                  <h3>II. ABOUT US</h3>
                  <p>
                    The use of our website and the services booked/ products
                    purchased are subject to the following terms of use:
                  </p>
                  <p>
                    1. The content on the pages of our website is for general
                    information and use only. It is subject to change without
                    notice.
                  </p>
                  <br />
                  <p>
                    2. Neither we nor any third parties provide any warranty or
                    guarantee on the accuracy, timeliness, performance,
                    completeness or suitability of the information and materials
                    found or offered on website for any particular purpose. You
                    acknowledge that such information and materials may contain
                    inaccuracies or errors and we expressly exclude liability
                    for any such inaccuracies or errors to the fullest extent
                    permitted by law.
                  </p>
                  <br />
                  <p>
                    3. Your use of any information or materials on our website
                    is entirely at your own risk, for which we shall not be
                    liable. It shall be your responsibility to ensure that
                    services, products or information available on the website
                    meet your specific requirements.
                  </p>
                  <br />
                  <p>
                    4. We have developed contents, material which is owned by or
                    licensed to us. This material includes, but is not limited
                    to, the design, layout, look, appearance and graphics.
                    Reproduction is prohibited other than in accordance with the
                    copyright notice, which forms part of these terms and
                    conditions.
                  </p>
                  <br />
                  <p>
                    5. All trademarks reproduced in our website which are not
                    the property of, or licensed to, the operator are
                    acknowledged on the website. No use of the intellectual
                    property owned or licensed to Dynamic World Education
                    Community Private Limited may be used without our prior
                    written authorization.
                  </p>
                  <br />
                  <p>
                    6. Unauthorized use of the website may invite claim for
                    damages or prosecuted for criminal offence.
                  </p>
                  <br />
                  <p>
                    7. Periodically we may include links to other websites.
                    These links are provided for your convenience to provide
                    further information. They do not signify that we endorse the
                    website(s). We have no responsibility for the content of the
                    linked website(s).
                  </p>
                  <br />
                  <p>
                    8. Under any circumstances no link to be created by you to
                    redirect our website to another forum, lead source, or
                    document without Dynamic World Education Community Private
                    Limited&rsquo;s prior written consent.
                  </p>
                  <br />
                  <p>
                    9. Your use and subsequent dispute arising out of use of the
                    website is subject to the laws in India or other regulatory
                    authority.
                  </p>
                  <br />
                  <p>
                    10. Your use of our products and services rendered herein
                    are solely for your personal and non-commercial use. Any use
                    other than for personal purposes is prohibited. Your
                    personal and non-commercial use of our services shall be
                    subjected to the following restrictions: i) You cannot
                    decompile, reverse engineer, or disassemble the contents of
                    our services, products, or (c) remove any copyright,
                    trademark registration, or other proprietary notices from
                    the contents of our website. ii) You will not (a) use our
                    product or service for commercial purposes of any kind, or
                    (b) advertise or sell any products, services or otherwise
                    (whether or not for profit), or solicit others (including,
                    without limitation, solicitations for contributions or
                    donations) or use any public forum for commercial purposes
                    of any kind, or (c) use our products and services in any way
                    that is unlawful, or harms Dynamic World Education Community
                    Private Limited or any other person or entity as determined
                    by Dynamic World Education Community Private Limited.
                  </p>
                  <br />
                  <p>
                    11. Dynamic World Education Community Private Limited
                    products and / or services, including the Dynamic World
                    Education Community Private Limited application and content,
                    may not be compatible to all devices.
                  </p>
                  <br />
                  <p>
                    12. Dynamic World Education Community Private Limited or any
                    of its subsidiaries or content partners shall have no
                    responsibility for any loss or damage caused to tablet or
                    phone or any other hardware and / or software, including
                    loss of data or effect on the processing speed of the
                    tablet, those results from the use of our products and
                    services.
                  </p>
                  <br />
                  <p>
                    13. In no manner Dynamic World Education Community Private
                    Limited be liable for damages of any kind, including without
                    limitation, (i) indirect, punitive, special, exemplary,
                    incidental, or consequential damage (including loss of
                    business, revenue, profits, use, data or other economic
                    advantage, loss of programs or information), or (ii) direct
                    damages in excess of the amount paid to Dynamic World
                    Education Community Private Limited for the product and / or
                    service, arising out of the use of, misuse of or inability
                    to use, or errors, omissions or other inaccuracies in the
                    Site or the products and / or services, or any information
                    provided on the Site. Some jurisdictions do not allow the
                    limitation or exclusion of liability. Accordingly, in such
                    instances, some of the above limitations may not apply to
                    the User.
                  </p>
                  <br />
                  <p>
                    14. Dynamic World Education Community Private Limited can
                    contact the user through sms, email and call to give
                    notifications on various important updates. Therefore, user
                    holds Dynamic World Education Community Private Limited non
                    liable to any liabilities including financial penalties,
                    damages, expenses in case the users mobile number is
                    registered with Do not Call (DNC) database.
                  </p>
                  <br />
                  <p>
                    15. You hereby indemnify, defend, and hold Dynamic World
                    Education Community Private Limited&rsquo;s distributors,
                    agents, representatives and other authorized users, and each
                    of the foregoing entities&rdquo; respective resellers,
                    distributors, service providers and suppliers, and all of
                    the foregoing entities&rsquo; respective officers,
                    directors, owners, employees, agents, representatives,
                    harmless from and against any and all losses, damages,
                    liabilities and costs arising from your use of our product.
                  </p>
                  <br />
                  <p>
                    16. In the event of breach of the terms and conditions of
                    this Terms of Use by the User, the User shall be promptly
                    liable to indemnify Dynamic World Education Community
                    Private Limited for all the costs, losses and damages caused
                    to Dynamic World Education Community Private Limited as a
                    result of such a breach.
                  </p>
                  <br />
                  <p>
                    17. In the event of your breach of this Terms of Use, you
                    agree that Dynamic World Education Community Private Limited
                    will be irreparably harmed and will not have an adequate
                    remedy in money or damages. Dynamic World Education
                    Community Private Limited therefore, shall be entitled in
                    such event to obtain an injunction against such a breach
                    from any court of competent jurisdiction immediately upon
                    request. Dynamic World Education Community Private
                    Limited&rsquo;s right to obtain such relief shall not limit
                    its right to obtain other remedies.
                  </p>
                  <br />
                  <p>
                    18. Persons who are &ldquo;competent/capable&rdquo; of
                    contracting within the meaning of the Indian Contract Act,
                    1872 shall be eligible to use our products or services.
                    Persons who are minors, un-discharged insolvents etc. are
                    not eligible to use our products or services. As a minor if
                    you wish to use our products or services, such use shall be
                    made available to you by your legal guardian or parents.
                    Dynamic World Education Community Private Limited will not
                    be responsible for any consequence that arises as a result
                    of misuse of any kind of our products or services that may
                    occur by virtue of any person including a minor using the
                    services provided. By using the products or services you
                    warrant that all the data provided by you is accurate and
                    complete and that you have obtained the consent of
                    parent/legal guardian(in case of minors). Dynamic World
                    Education Community Private Limited reserves the right to
                    terminate your subscription and / or refuse to provide you
                    with access to the products or services if it is discovered
                    that you are under the age of 18 years and the consent to
                    use the products or services is not made by your
                    parent/legal guardian or any information provided by you is
                    inaccurate.
                  </p>
                  <br />
                  <p>
                    19. The users of our website shall not host, display,
                    upload, modify, publish, transmit, update or share any
                    information:
                  </p>
                  <p>
                    a) to another person and to which the user does not have any
                    right to;
                  </p>
                  <p>
                    b) is grossly harmful, harassing, blasphemous defamatory,
                    obscene, pornographic, paedophilic, libellous, invasive of
                    another's privacy, hateful, or racially, ethnically
                    objectionable, disparaging, relating or encouraging money
                    laundering or gambling, or otherwise unlawful in any manner
                    whatever;
                  </p>
                  <p>c) harm minors in any way;</p>
                  <p>
                    d) infringes any patent, trademark, copyright or other
                    proprietary rights;
                  </p>
                  <p>e) violates any law for the time being in force;</p>
                  <p>
                    f) deceives or misleads the addressee about the origin of
                    such messages or communicates any information which is
                    grossly offensive or menacing in nature;
                  </p>
                  <p>g) impersonate another person;</p>
                  <p>
                    h) contains software viruses or any other computer code,
                    files or programs designed to interrupt, destroy or limit
                    the functionality of any computer resource;
                  </p>
                  <p>
                    i) threatens the unity, integrity, defence, security or
                    sovereignty of India, friendly relations with foreign
                    states, or public order or causes incitement to the
                    commission of any cognisable offence or prevents
                    investigation of any offence or is insulting any other
                    nation.
                  </p>
                  <br />
                  <p>
                    20. The users of our website shall not host, display,
                    upload, modify, publish, transmit, update or share any
                    information:
                  </p>
                  <p>
                    a) to another person and to which the user does not have any
                    right to;
                  </p>
                  <p>
                    b) is grossly harmful, harassing, blasphemous defamatory,
                    obscene, pornographic, paedophilic, libellous, invasive of
                    another's privacy, hateful, or racially, ethnically
                    objectionable, disparaging, relating or encouraging money
                    laundering or gambling, or otherwise unlawful in any manner
                    whatever;
                  </p>
                  <p>c) harm minors in any way;</p>
                  <p>
                    d) infringes any patent, trademark, copyright or other
                    proprietary rights;
                  </p>
                  <p>e) violates any law for the time being in force;</p>
                  <p>
                    f) deceives or misleads the addressee about the origin of
                    such messages or communicates any information which is
                    grossly offensive or menacing in nature;
                  </p>
                  <p>g) impersonate another person;</p>
                  <p>
                    h) contains software viruses or any other computer code,
                    files or programs designed to interrupt, destroy or limit
                    the functionality of any computer resource;
                  </p>
                  <p>
                    i) threatens the unity, integrity, defence, security or
                    sovereignty of India, friendly relations with foreign
                    states, or public order or causes incitement to the
                    commission of any cognisable offence or prevents
                    investigation of any offence or is insulting any other
                    nation.
                  </p>
                  <br />
                  <p>
                    We will not be liable for any non-compliance or delay in
                    compliance with any of the obligations we assume under any
                    contract when caused by events that are beyond our
                    reasonable control or on account of force majeure.
                  </p>
                  <br />
                  <br />
                  <h3>III.TERM &amp; TERMINATION</h3>
                  <br />
                  <p>
                    1.This Terms &amp; Conditions will remain in full force and
                    effect until terminated, for using the platform or
                    purchasing the products in any form or capacity. Provided,
                    we have the right to immediately terminate your access or
                    usage and remove non-compliant information or material, in
                    case of non-compliance with the terms and conditions or our
                    privacy policy
                  </p>
                  <br />
                  <p>
                    2.The user shall be obligated to clear any dues with us for
                    any of its Services which you have procured. Dynamic World
                    Education Community Private Limited shall not be liable to
                    you or any third party for any termination of your access to
                    the Services.
                  </p>
                  <h3>IV.GOVERNING LAW</h3>
                  <br />
                  <p>
                    1.The jurisdictional court of Vadodara, India shall have
                    sole jurisdiction over any claim arising from, or related
                    to, a visit to / use of the platform or purchase of the
                    products. In case you are from a different country, we
                    retain the right to bring proceedings against you for breach
                    of any of the terms and conditions in your country of
                    residence, country of use or other relevant country. The
                    laws of Vadodara, India govern this Agreement and these
                    terms and conditions of use of the website.
                  </p>
                  <br />
                  <p>
                    2.Dynamic World Education Community Private Limited accepts
                    no liability whatsoever, direct or indirect, for
                    non-compliance with the laws of any country other than that
                    of India, and the mere fact that the platform can be
                    accessed or used in a country other than India will not
                    imply that we accede to the laws of such country.
                  </p>
                  <h3>V.CONTACT US</h3>
                  <p>
                    If you have any questions or complaints about the online
                    DWEC Academy/ test preparation package, the website and
                    it&rsquo;s contents please write to us at
                    marketing@dynamicwec.net
                  </p>
                  <h3>VI. Student's Terms &amp; Conditions</h3>
                  <br />
                  <p>
                    The student agrees to authorize Dynamic World Education
                    Community as his/her agent and help with his/her
                    applications &amp; other admission related services.
                  </p>
                  <br />
                  <p>
                    The student agrees to change his/her agent to Dynamic World
                    Education Community in case there is another agent already
                    authorized prior to this.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}

export default TermsAndConditions;
